import React, { FC, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { RootState } from '../../../../states/containers/store'

import { setPath } from '../../../../utils/url'
import { URL } from '../../../constants/url'

import { fetchTaskExportDetail } from '../../../../states/containers/task/taskSlice'

const Download: FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { id } = useParams<{ id: string }>()

  const {
    commonPart,
  } = useSelector((state: RootState) => (state))

  useEffect(() => {
    if (!id) return
    dispatch(
      fetchTaskExportDetail(
        { id: id },
        (url) => {
          window.location.href = url
          history.push({ pathname: setPath(URL.TASK_CSV_EXPORT.path, commonPart.language as string), state: true })
        },
      ),
    )
  }, [])

  return (
    <>
      <Helmet>
        <title>Qasee - データエクスポート - ダウンロード</title>
      </Helmet>
    </>
  )
}
export default Download
